export const verbiage = {
  pageTitle: 'Make Payment for Failed Transactions',
};
